import React from 'react';

import DataForm from './components/DataForm';

const Container = () => <DataForm />;

export default Container;
